import React, { useRef, useState, useEffect, useCallback } from "react";
import styles from "./customTabs.scss";

interface Tab {
  key: string;
  label: React.ReactNode;
  content: React.ReactNode;
}

interface CustomTabsProps {
  tabs: Tab[];
  activeKey: string;
  onChange: (key: string) => void;
  className?: string;
  vertical?: boolean;
}

var SCROLL_DISTANCE = 150;

var CustomTabs = function (props) {
  var tabs = props.tabs;
  var activeKey = props.activeKey;
  var onChange = props.onChange;
  var className = props.className;
  var vertical = props.vertical;

  var activeTab = tabs.find(function (t) { return t.key === activeKey; });
  var activeContent = activeTab ? activeTab.content : null;
  var scrollRef = useRef(null);
  var showLeftArrow = useState(false);
  var showRightArrow = useState(false);
  var setShowLeftArrow = showLeftArrow[1];
  var setShowRightArrow = showRightArrow[1];

  var updateArrows = useCallback(function () {
    var el = scrollRef.current;
    if (!el) return;
    setShowLeftArrow(el.scrollLeft > 0);
    setShowRightArrow(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  }, []);

  useEffect(function () {
    if (vertical) return;
    var el = scrollRef.current;
    if (!el) return;
    var activeEl = el.children[tabs.findIndex(function (t) { return t.key === activeKey; })];
    if (activeEl) {
      activeEl.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
    }
  }, [activeKey, vertical]);

  useEffect(function () {
    if (vertical) return;
    updateArrows();
    var el = scrollRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
    return function () {
      el.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, [vertical, updateArrows]);

  var scroll = function (direction) {
    var el = scrollRef.current;
    if (!el) return;
    el.scrollBy({
      left: direction === "left" ? -SCROLL_DISTANCE : SCROLL_DISTANCE,
      behavior: "smooth"
    });
  };

  if (vertical) {
    return (
      <div className={`${styles.customTabsVerticalWrapper} ${className || ''}`}>
        <div className={`${styles.customTabs} ${styles.customTabsVertical}`}>
          {tabs.map(function (tab) {
            return (
              <div
                key={tab.key}
                className={`${styles.customTabVertical} ${activeKey === tab.key ? styles.customTabVerticalActive : ''}`}
                onClick={function () { onChange(tab.key); }}
                data-label={tab.label}
              >
                {tab.label}
              </div>
            );
          })}
        </div>
        <div className={styles.customTabsContent}>
          {activeContent}
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className={styles.customTabsWrapper}>
        {showLeftArrow[0] && (
          <div className={`${styles.arrow} ${styles.arrowLeft}`} onClick={function () { scroll("left"); }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        )}
        <div className={`${styles.customTabs} ${className || ''}`} ref={scrollRef}>
          {tabs.map(function (tab) {
            return (
              <div
                key={tab.key}
                className={`${styles.customTab} ${activeKey === tab.key ? styles.customTabActive : ''}`}
                onClick={function () { onChange(tab.key); }}
              >
                {tab.label}
              </div>
            );
          })}
        </div>
        {showRightArrow[0] && (
          <div className={`${styles.arrow} ${styles.arrowRight}`} onClick={function () { scroll("right"); }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        )}
      </div>
      {activeContent}
    </React.Fragment>
  );
};

export default CustomTabs;



// WEBPACK FOOTER //
// ./src/components/CustomTabs/CustomTabs.tsx